export const getUnmaskedValue = (str: string) => {
  return str.replace(/\W/g, '');
};

export const getOnlyNumbers = (str: string | number) => {
  return String(str).replace(/\D/g, '');
};

export const getFormattedPhone = (phone: string) => {
  phone = phone || '';
  return (
    '(' +
    phone.toString().substr(0, 2) +
    ') ' +
    phone.toString().substr(2, 4) +
    '.' +
    phone.toString().substr(6)
  );
};

export const getFormattedCPF = (cpf: string) => {
  return (
    cpf.substr(0, 3) +
    '.' +
    cpf.substr(3, 3) +
    '.' +
    cpf.substr(6, 3) +
    '-' +
    cpf.substr(9, 2)
  );
};

export const getFormattedCNPJ = (cpf: string) => {
  return (
    cpf.substr(0, 2) +
    '.' +
    cpf.substr(2, 3) +
    '.' +
    cpf.substr(5, 3) +
    '/' +
    cpf.substr(8, 4) +
    '-' +
    cpf.substr(12, 2)
  );
};

export const getFormattedDate = (input: string) => {
  const value = String(input)
    .replace(/\D/g, '') // Retira o que não é número
    .slice(0, 8) // Limita o tamanho
    .replace(/(\d{2})(\d{1,})/, '$1/$2') // Coloca a primeira barra
    .replace(/(\d{2}\/\d{2})(\d{1,2})/, '$1/$2') // Coloca a segunda barra
    .replace(/(\d{2}\/\d{2}\/)(\d{1,4}) /, '$1/$2'); // Coloca a terceira barra
  return value;
};

export const getFormattedPeriod = (str: string) => {
  const unformatted = getOnlyNumbers(str).trim();
  if (!unformatted.length) {
    return '';
  }
  return unformatted
    .substring(0, 6)
    .replace(/^([2-9])/, '')
    .replace(/^(0)(0)/, '$1')
    .replace(/^(1)([3-9])/, '$1')
    .replace(/^(\d{2})(\d{1,4})$/, '$1/$2');
};
